<template>
  <div :style="gridMenuStyle" class="gridMenuClass">
    <div class="header">
      {{$t('lcd.Editor.Grid Settings')}}
      <div class="btn">
        <tumeng-svg-icon
          style="font-size: 18px; margin-top: 3px"
          class-name="close"
          icon-class="close"
          @click.native="handleClose"
        />
      </div>
    </div>
    <div class="divider"></div>
    <div class="item">
      <div class="label">{{$t('lcd.Editor.Grid Switch')}}</div>
      <el-switch
        v-model="store.state.gridVisible"
        class="content"
        active-color="#13ce66"
        inactive-color="#d2d2d2"
      />
    </div>
    <div class="item">
      <div class="label">{{$t('lcd.Editor.Grid Width')}}</div>
      <div class="content width-wrap">
        <div
          v-for="it in widthList"
          :key="it"
          :class="['size', { active: store.state.gridWidth === it }]"
          @click="handleSelectGridWidth(it)"
        >
          {{ it }}
        </div>
      </div>
    </div>
    <div class="item">
      <div class="label" style="height: 28px; line-height: 28px">
        {{$t('lcd.Editor.Grid Line Color')}}
      </div>
      <div class="content">
        <el-color-picker
          v-model="store.state.gridColor"
          show-alpha
          :predefine="predefineColors"
          size="mini"
        />
      </div>
    </div>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import Clickoutside from "../../../utils/clickoutside";
import { predefineColors } from "../../../utils/constant";

export default {
  name: "GridMenu",
  directives: {
    Clickoutside,
  },
  data() {
    return {
      store,
      predefineColors,
      widthList: [5, 8, 10, 16, 20, 32, 40, 80],
    };
  },
  computed: {
    // 右键菜单的样式
    gridMenuStyle() {
      return {
        display: store.state.gridMenuVisible ? "block" : "none",
        // 减一是让菜单弹出来的时候就选第一个菜单项
        left: store.state.gridMenuLeft + "px",
        top: store.state.gridMenuTop + "px",
      };
    },
  },
  methods: {
    handleSelectGridWidth(it) {
      console.log("click");
      store.updateGridWidth(it);
    },
    handleClose() {
      store.updateGridMenuArgs(false);
    },
  },
};
</script>

<style lang="scss" scoped>
// 右键菜单
.gridMenuClass {
  border-radius: 4px;
  position: absolute;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  z-index: 11;
  > div {
    padding: 4px 8px;
    user-select: none;
    &:first-of-type {
      border-radius: 4px 4px 0 0;
    }
    &:last-of-type {
      border-radius: 0 0 4px 4px;
    }
    &.divider {
      height: 1px;
      margin: 4px 0 12px;
      padding: 0;
      background-color: #aaa;
    }
    &.header {
      line-height: 24px;
      .btn {
        width: 30px !important;
        float: right;
        font-size: 14px;
        padding: 0;
        cursor: pointer;
      }
    }
    &.item {
      &:after {
        content: "";
        display: block;
        clear: both;
      }
      .label,
      .content {
        float: left;
      }
      .label {
        width: 100px;
      }
      .content {
        &:after {
          content: "";
          display: block;
          clear: both;
        }
        &.width-wrap {
          border: 1px solid #f66;
          line-height: 24px;
        }
        .size {
          float: left;
          padding: 0 8px;
          &.active {
            background-color: #f66;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
